import { Injectable } from '@angular/core';
import { NetworkService } from "../../common/network.service";


@Injectable({
  providedIn: 'root'
})
export class ReportedAnswereService {

  constructor(private _networkService: NetworkService) { }




  GetreportedList() {
    return this._networkService.get("api/answer/reported", null, null, "bearer")
  }
  reportedAnswere(body: any) {
    return this._networkService.put("api/answer", body, null, "bearer")
  }
  DeletereportedAnswere(id: any) {
    return this._networkService.delete("api/answer/"+id, null, null, "bearer")
  }

  DeletereportedQuestion(id: any) {
    return this._networkService.delete("api/question/"+id, null, null, "bearer")
  }
  GetReportDetail(param: any) {
    return this._networkService.get("api/answer/reported/details/" + param, null, null, "bearer")
  }
  GetReportQuestionDetail(param: any) {
    return this._networkService.get("api/question/reported/details/" + param, null, null, "bearer")
  }
  GetreportedQuestion() {
    return this._networkService.get("api/question/reported", null, null, "bearer")
  }
  clearReport(body: any) {
    return this._networkService.put("api/answer/reported/clearList", body, null, "bearer")
  }
  clearReportedUsers(body: any) {
    return this._networkService.post("api/users/reports/delete", body, null, "bearer")
  }
  GetReportedUser() {
    return this._networkService.get("api/users/reported/list" , null, null, "bearer")
  }
  updateUserStatus(user: any) {
    return this._networkService.put("api/users", user, null, "bearer");
  }

}
